import { useState } from 'react';
import TopBar from './components/TopBar';
import TacticalMap from './components/TacticalMap';
import { useMapData } from './hooks/useMapData';

/**
 * Drop this into your router, e.g.:
 *   <Route path="/map" component={MapPage} />
 *
 * It's fully self-contained: fetches data (local JSON for now, Google
 * Drive later — see hooks/useMapData.ts), renders the top bar and the
 * pan/zoom map, and owns the layer-visibility state.
 */
export default function MapPage() {
  const { crashes, loot, loading, error } = useMapData();
  const [mapId, setMapId] = useState('chernarus');
  const [showCrashes, setShowCrashes] = useState(true);
  const [showLoot, setShowLoot] = useState(true);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <TopBar
        mapId={mapId}
        onMapChange={setMapId}
        showCrashes={showCrashes}
        showLoot={showLoot}
        onToggleCrashes={() => setShowCrashes((v) => !v)}
        onToggleLoot={() => setShowLoot((v) => !v)}
        crashCount={crashes.length}
        lootCount={loot.length}
      />
      <div style={{ flex: 1, position: 'relative' }}>
        {loading && <CenteredNote text="Загрузка данных…" />}
        {error && <CenteredNote text={`Ошибка загрузки: ${error.message}`} />}
        {!loading && !error && (
          <TacticalMap
            mapId={mapId}
            crashes={crashes}
            loot={loot}
            showCrashes={showCrashes}
            showLoot={showLoot}
          />
        )}
      </div>
    </div>
  );
}

function CenteredNote({ text }: { text: string }) {
  return (
    // <div
    //   style={{
    //     position: 'absolute',
    //     inset: 0,
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     color: '#8b9488',
    //     fontFamily: "'JetBrains Mono', monospace",
    //     fontSize: 13,
    //     background: '#0a0e0c',
    //   }}
    // >
    //   {text}
    // </div>
      <></>
  );
}
